<template>
   <div id="container" style="    width: 100%;   ">
      <a-spin :spinning="reloading">
         <Font></Font>
         <div style="display: flex;margin-bottom: 20px;"> <a-range-picker format="YYYY-MM-DD" v-model:value="rangeTime"
               @change="changeTime" />
            <search-type-component v-model:searchType="searchType"  @changeSearchType="changeSearchType" />
            <div  style="position: relative;flex: 1;">
                  <a-input placeholder="搜索内容" ref="searchRef"   v-model:value="title" @blur="defaultKeywordShow=false"   @focus="defaultKeywordShow=true" allowClear @pressEnter="onSearch"></a-input>
                  <default-keyword-component :defaultKeywordShow="defaultKeywordShow" @clickKeyword="clickKeyword"></default-keyword-component>
            </div>

            <a-button type="primary" style="width: 100px;background: #00b2b9;border-color: #00b2b9;" @click="onSearch" >
               <template #icon>
                  <SearchOutlined  style="color: white;"/>
               </template>
            </a-button>
         </div>
         <div  @scroll="handleScroll" class="scrollView" :style="scrollView">
            <div>
               <Article :article="item" :favor="true" v-for="item, index in articleList" v-bind:key="item"
                  :updateTime="index > 0 ? articleList[index - 1].updateTime : ''"></Article>
            </div>
            <div v-if="articleList.length == pagination.total">
               <Bottom></Bottom>
            </div>
         </div>
      </a-spin>
   </div>
   <!--<a-modal  v-model:visible="visible" :bodyStyle="{height:'90%',width:'500px'}">
      <iframe src="https://www.enplus.org.cn/vuePostertest/#/?id=129512&companyId=32&loading=true"></iframe>
   </a-modal>-->
</template>
<script>
import { SearchOutlined } from '@ant-design/icons-vue';
import { myArticleFavorList } from '../../views/js/index'
import { reactive, watch, ref, onMounted, onActivated, nextTick } from 'vue'
import store from '@/store'
import Article from '../articleComponent/Article'
import Bottom from '../articleComponent/Bottom'
import dayjs from 'dayjs'
import Font from '../articleComponent/Font'
import { createTitle } from '@/untils';
import SearchTypeComponent from './component/searchTypeComponent.vue'
import DefaultKeywordComponent from './component/defaultKeywordComponent.vue'
export default {
   components: { Article, SearchOutlined, Font, Bottom,SearchTypeComponent,DefaultKeywordComponent },
   name: 'homePage',
   setup() {
      watch(() => store.getters.company, (val) => {
         if (val && val != '') {
            var height = document.getElementById('container').offsetHeight
            scrollView.value = { height: (height - 100) + 'px', overflow: 'auto' }
            pagination.companyId = store.getters.company.companyId
            toShowTable()
         }
      })
      watch(
         () => store.getters.reloadFavorFlag,
         (val) => {
            if (val == true) {
               pagination.current = 1
               articleList.value = []
               //document.querySelector('.scrollView').scrollTop =  scrollY.value=0
               // store.dispatch('reloadFavorFlag',false)
            }
         })
      onActivated(() => {
         if (store.getters.reloadFavorFlag == true) {
            articleList.value = []
            pagination.current = 1
            toShowTable()
            document.querySelector('.scrollView').scrollTop = scrollY.value = 0
            store.dispatch('reloadFavorFlag', false)
         }
         else {
            if (articleList.value.length == 0) {
               var height = document.getElementById('container').offsetHeight
               scrollView.value = { height: (height - 120) + 'px', overflow: 'auto' }
               if (store.getters.company) {
                  pagination.companyId = store.getters.company.companyId
                  toShowTable()
               }
            }
            else {
               document.querySelector('.scrollView').scrollTop = scrollY.value
            }
         }
      })
      const toShowTable = () => {
         reloading.value = true
         var startTime = ''
         var endTime = ''
         if (rangeTime.value[0] != '') {
            startTime = dayjs(rangeTime.value[0]).format(dateFormat) + " 00:00:00"
            endTime = dayjs(rangeTime.value[1]).format(dateFormat) + " 23:59:59"
         }
         var list = {queryType:searchType.value, current: pagination.current, companyId: pagination.companyId, size: 10, title: title.value, startTime: startTime, endTime: endTime }
         myArticleFavorList(list).then((res) => {
            pagination.total = res.data.total
            articleList.value = createTitle(store.getters.company.companyId, pagination.current == 1 ? res.data.records : articleList.value.concat(res.data.records))
            reloading.value = false
         })
      }
      const pagination = reactive({
         current: 1,
         size: 10,
         companyId: '',
         total: 0
      })
      const articleList = ref([])
      const scrollView = ref('')
      const dateFormat = 'YYYY-MM-DD';
      const handleScroll = (e) => {
         let scrollTop = e.target.scrollTop; //滑入屏幕滚动条滚动时，距离顶部的距离
         let windowHeitht = e.target.clientHeight; //能看到的页面的高度
         let scrollHeight = e.target.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
         let total = scrollTop + windowHeitht
         if (scrollHeight - total < 20) {
            if (articleList.value.length != pagination.total) {
               if (reloading.value == false) {
                  pagination.current = pagination.current + 1
                  toShowTable()
               }
            }
         }
      }
      const reloading = ref(false)
      const visible = ref(true)
      const title = ref('')
      const rangeTime = ref(['', ''])
      const changeTime = () => {
         if (rangeTime.value == null) {
            rangeTime.value = ['', '']
         }
         onSearch()
      }
      const onSearch = () => {
         articleList.value = []
         pagination.current = 1

         toShowTable()
      }
      const scrollY = ref(0)
      const searchType = ref(0)
      const defaultKeywordShow =ref(false)
       const clickKeyword=(item)=>{
         title.value=item
         nextTick().then(()=>{
           searchRef.value.blur()
              onSearch()
         })
      }
        const changeSearchType=(val)=>{
         searchType.value=val
         if(title.value!='')
         onSearch()
      }
      const searchRef=ref(null)
      return {
         searchRef,
         changeSearchType,
         clickKeyword,
         defaultKeywordShow,
         searchType,
         scrollY,
         onSearch,
         changeTime,
         rangeTime,
         title,
         visible,
         reloading,
         scrollView,
         handleScroll,
         articleList,
         toShowTable,
         pagination,
      }
   },
   beforeRouteLeave(to, from, next) {
      //保存滚动条元素div的scrollTop值
      this.scrollY = document.querySelector('.scrollView').scrollTop
      next();
   },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.scrollView {
   margin: 10px 0px;
}
</style>
